// @ts-nocheck

import { EditTwoTone } from '@ant-design/icons';
import React, { Component } from 'react';
import styled from 'styled-components';
import notification from 'antd/lib/notification';
import { Link } from '../../../lib/routerAdapter';


import { Popconfirm, Icon, ListTable } from './../../../components/ui';
import {
  applyMaskToValue,
  formatDateTimeToString } from
'./../../../lib/helpers';
import { osagoApi } from '../../../lib/api';
import { notificationLoading } from './../../../components/Notifications';
import { formatOsagoMask } from '../../../components/inputs/masked-inputs/OsagoInput';


const StyledIcon = styled(Icon)`
  cursor: pointer;
`;

const StyledAntIcon = styled(EditTwoTone)`
  cursor: pointer;
  color: #2b7cff;
  margin-right: 10px;
`;

const Operations = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;











class OsagoList extends Component {
  state = {
    loading: false,
    osagos: []
  };

  async componentDidMount() {
    await this.fetchOsagos();
  }

  fetchOsagos = async () => {
    try {
      this.setState({
        loading: true
      });
      const osagos = await osagoApi.fetchVehicleOsagos(this.props.vehicleId);
      this.setState({
        osagos: osagos.data
      });
    } catch (err) {
      notification.error({
        message: 'Ошибка',
        description: err.message
      });
    } finally {
      this.setState({
        loading: false
      });
    }
  };

  onDelete = async (osago) => {
    try {
      notificationLoading({
        message: 'Удаление...',
        key: 'deleting'
      });
      if (osago.id) {
        await osagoApi.deleteOsago(osago.id);
        notification.success({
          message: `ОСАГО успешно удален`
        });
        await this.fetchOsagos();
      }
    } catch (err) {
      notification.error({
        message: 'Ошибка',
        description: err.message
      });
    } finally {
      notification.destroy('deleting');
    }
  };

  render() {
    const { enableDelete } = this.props;
    const { osagos, loading } = this.state;
    return (
      <ListTable
        isLoading={loading}
        columns={[
        {
          title: 'Серия и номер ОСАГО',
          key: 'osagoNumber',
          render: (osagoNumber) =>
          applyMaskToValue(osagoNumber, formatOsagoMask)
        },
        {
          title: 'Дата окончания',
          key: 'osagoFinishedDate',
          render: (value) =>
          formatDateTimeToString(value, 'DD.MM.YYYY')
        },
        {
          title: 'Сумма оплаты',
          key: 'paymentAmount',
          render: (value) => (value || 0) + ' руб.'
        },
        {
          title: 'Наименование страховщика',
          key: 'contractor',
          render: (contractor) =>
          contractor && contractor.company.name || '-'
        },
        {
          title: 'Серия и номер диагностической карты',
          key: 'diagnosticCardNumber'
        },
        {
          width: '20px',
          renderRecord: (record) =>
          record && enableDelete ?
          <Operations>
                  <Link
              to={`/vehicles/${this.props.vehicleId}/osagos/${parseInt(
                record.id
              )}`}>

                    <StyledAntIcon />
                  </Link>
                  <Popconfirm
              placement="topRight"
              title="Вы действительно хотите удалить?"
              okText="Да"
              cancelText="Нет"
              onConfirm={() => this.onDelete(record)}>

                    <StyledIcon type="x" />
                  </Popconfirm>
                </Operations> :
          null
        }]
        }
        data={osagos} />);


  }
}

export default OsagoList;
